import React from "react";
import OptionsSwal from "../../components/Swal/optionsSwal";
import CommonSwal from "../../components/Swal/commonSwal";
import Card from "../../components/page/Card";
import LinksDatatable from "./CentralAjudaLinks/LinksDatatable";
import LinkModal from "./CentralAjudaLinks/LinkModal";
import Validation from "../../helpers/Validation";
import ErrorSwal from "../../components/Swal/errorSwal";
import linksAjudaApiClient from "../../api/linksAjuda";
import useApi from "../../hooks/useApi";

function CentralAjudaLinks() {
  const [links, setLinks] = React.useState([]);
  const [linkModal, setLinkModal] = React.useState(false);
  const [values, setValues] = React.useState({});

  const { request: getLinks, data: linksResponse } = useApi(
    linksAjudaApiClient.listLinks
  );
  const postLinksApi = useApi(linksAjudaApiClient.postLinks);
  const putLinkApi = useApi(linksAjudaApiClient.putLinks);
  const deleteLinkApi = useApi(linksAjudaApiClient.deleteLinks);

  //Busca dados dos cards ao renderizar tela
  React.useEffect(() => {
    getLinks();
  }, [getLinks]);

  //Define o retorno da api no valor do estado
  React.useEffect(() => {
    if (linksResponse) setLinks(linksResponse);
  }, [linksResponse]);

  const togNovoLinkModal = async () => {
    setValues({});
    setLinkModal(true);
  };

  const togEditarLinkModal = (data) => {
    setValues(data);
    setLinkModal(true);
  };

  const deletarLink = async (uid) => {
    OptionsSwal({
      title: "Você tem certeza que deseja excluir este link?",
      icon: "warning",
    }).then(async (result) => {
      if (result.isConfirmed) {
        const response = await deleteLinkApi.request(uid);
        if (!response) return;
        CommonSwal({
          title: "Link excluído com sucesso!",
          icon: "success",
        }).then(async (result) => {
          if (result.isConfirmed || result.isDismissed) {
            getLinks();
            setLinkModal(false);
          }
        });
      }
    });
  };

  const salvaLink = async () => {
    const formData = new FormData();
    formData.append("identificador", values.identificador);
    formData.append("link", values.link);

    if (Validation.verificarForm(formData))
      return ErrorSwal({
        text: "Favor preencher todos os dados obrigatórios.",
      });

    const response = await putLinkApi.request(values?.uid, formData);

    if (response) {
      CommonSwal({
        title: "Link salvo com sucesso!",
        icon: "success",
      }).then((result) => {
        if (result.isConfirmed || result.isDismissed) {
          getLinks();
          setLinkModal(false);
        }
      });
    }
  };

  const novoLink = async () => {
    const formData = new FormData();
    formData.append("identificador", values.identificador);
    formData.append("link", values.link);

    if (Validation.verificarForm(formData))
      return ErrorSwal({
        text: "Favor preencher todos os dados obrigatórios.",
      });

    const response = await postLinksApi.request(formData);

    if (response) {
      CommonSwal({
        title: "Link salvo com sucesso!",
        icon: "success",
      }).then((result) => {
        if (result.isConfirmed || result.isDismissed) {
          getLinks();
          setLinkModal(false);
        }
      });
    }
  };

  return (
    <Card>
      <LinksDatatable
        deletarLink={deletarLink}
        linhas={links}
        togEditarLinkModal={togEditarLinkModal}
        togNovoLinkModal={togNovoLinkModal}
      />
      <LinkModal
        isOpen={linkModal}
        setIsOpen={setLinkModal}
        novoLink={novoLink}
        salvaLink={salvaLink}
        valuesHook={{ values, setValues }}
      />
    </Card>
  );
}

export default CentralAjudaLinks;
